export default "__VITE_ASSET__BZF8W3M1__"